import { useContext } from 'react';
import { BimTrackConfigurationContext } from "@ui/shared/context/BimTrackConfigurationsProvider";
import type { Configurations } from "@env/EnvironmentVariables";
import { NoContextError } from "@fileManagement/shared/exceptions/NoContextError";

export function useBimTrackConfiguration(): Configurations {
  const configurations = useContext(BimTrackConfigurationContext);

  if (!configurations) {
    throw new NoContextError("BimtrackConfigurationContext");
  }

  return configurations;
}
